import { IconProp } from "@fortawesome/fontawesome-svg-core";
import { faCaretDown } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button, Dropdown, MenuProps, Space, Spin } from "antd";
import { ItemType } from "antd/es/menu/interface";
import { MouseEventHandler } from "react";
import { useIntl } from "react-intl";

interface IProps {
  items: ItemType[];
  id: string;
  title?: string;
  open?: boolean;
  disabled?: boolean;
  loading?: boolean;
  handleClick?: MouseEventHandler;
  handleMenuClick?: MenuProps["onClick"];
}

export const OptionDropdown = ({
  items,
  id,
  title,
  open,
  disabled,
  loading,
  handleClick,
  handleMenuClick,
}: IProps) => {
  const intl = useIntl();
  return (
    <Dropdown
      data-test-id={`options-dropdown-${id}`}
      menu={{ items: items, onClick: handleMenuClick }}
      placement="bottom"
      open={open}
      disabled={disabled || loading}
    >
      <Button
        data-test-id={`options-dropdown-button-${id}`}
        onClick={handleClick}
      >
        <Space>
          <span>
            {title
              ? title
              : intl.formatMessage({
                  id: "general.options",
                })}
          </span>
          {loading ? (
            <Spin />
          ) : (
            <FontAwesomeIcon icon={faCaretDown as IconProp} />
          )}
        </Space>
      </Button>
    </Dropdown>
  );
};
